













import { defineComponent } from '@vue/composition-api';
import OlbBackButton from '../backButton';

export default defineComponent({
	components: {
		OlbBackButton,
	},
	props: {
		backButtonUrl: {
			type: String,
		},
		backbutton: {
			type: String,
		},
		headline: {
			type: String,
		},
		results: {
			type: String,
		},
	},
});
